import { render, staticRenderFns } from "./DoneIcon.vue?vue&type=template&id=01057a9b&scoped=true"
import script from "./DoneIcon.vue?vue&type=script&lang=js"
export * from "./DoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01057a9b",
  null
  
)

export default component.exports